import React from "react";
import { Row, Col } from "reactstrap";
import DoughnutChart from "pages/Dashboard/DoughnutChart";
import FeeCards from "pages/Locations/FeeCards";

/**
 * Render revenue + expense charts and fee cards
 * @param {object} stats - object from computeReportStats with charts
 */
const ReportStatsView = ({ stats }) => {
    if (!stats) return null;

    return (
        <Row>
            <Col xl={6}>
                <DoughnutChart {...stats.revenueChart} />
            </Col>
            <Col xl={6}>
                <DoughnutChart {...stats.expenseChart} />
            </Col>
            <Col xl={12}>
                <FeeCards
                    billables={stats.revenues}
                    billableTitle="Revenues"
                    payables={stats.expenses}
                    payableTitle="Expenses"
                    sm={6}
                    md={6}
                    locationIds={stats.locationIds}
                    start_date={stats.start_date}
                    end_date={stats.end_date}
                />
            </Col>
        </Row>
    );
};

export default ReportStatsView;